import { OrgServiceMemberDto } from './org-service';

export enum OrgMemberRole {
  GUEST = 'guest',
  CLIENT = 'client',
  MEMBER = 'member',
  MANAGER = 'manager',
  OWNER = 'owner',
}

export const OrgMemberRoleLabelMap = {
  [OrgMemberRole.OWNER]: 'Owner',
  [OrgMemberRole.CLIENT]: 'Client',
  [OrgMemberRole.MEMBER]: 'Member',
  [OrgMemberRole.MANAGER]: 'Manager',
  [OrgMemberRole.GUEST]: 'Guest',
};

export const OrgMemberRoleLabelLocKeyMap = {
  [OrgMemberRole.OWNER]: 'shared.roles.owner',
  [OrgMemberRole.CLIENT]: 'shared.roles.client',
  [OrgMemberRole.MEMBER]: 'shared.roles.member',
  [OrgMemberRole.MANAGER]: 'shared.roles.manager',
  [OrgMemberRole.GUEST]: 'shared.roles.guest',
};

export interface OrgMember {
  globalId: string;
  orgId: string;
  userId: number;
  createdAt: number;
  updatedAt: number;
  role: OrgMemberRole;
  disabled?: boolean; // Optional as it's not in the required list
  expiresAt?: number | null; // Optional and nullable
  memberTTL?: number | null; // Optional and nullable
}

export const memberRolesOrder = {
  [OrgMemberRole.OWNER]: 1,
  [OrgMemberRole.MANAGER]: 2,
  [OrgMemberRole.MEMBER]: 3,
  [OrgMemberRole.CLIENT]: 4,
  [OrgMemberRole.GUEST]: 5,
};

export function orgMembersFromDtos(dtos: OrgServiceMemberDto[]): OrgMember[] {
  return dtos.map((dto) => orgMemberFromDto(dto));
}
export function orgMemberFromDto(dto: OrgServiceMemberDto): OrgMember {
  return {
    globalId: dto.globalId,
    orgId: dto.orgId,
    userId: dto.userId,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    role: dto.role as OrgMemberRole,
    disabled: dto.disabled,
    expiresAt: dto.expiresAt ?? null,
    memberTTL: dto.memberTTL ?? null,
  };
}
